import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ClientRecycablesTable from "components/Admin/Users/Clients/Client/ClientRecycablesList";

import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";

import { getClientRecycables } from "store/actions/usersClients";

const ClientRecycables = () => {
  const recycablesData = useSelector(
    (state) => state.usersClients.clientRecycables
  );
  const dispatch = useDispatch();
  const { id } = useParams();
  const [page, setPage] = useState(
    recycablesData ? recycablesData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    recycablesData ? recycablesData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    recycablesData ? recycablesData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    recycablesData ? recycablesData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    recycablesData ? recycablesData.pag.search_by : "item_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getClientRecycables(
        {
          client_id: id,
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [id, page, amount, orderField, orderType, searchValue, dispatch]);

  const showRecycableHandler = (id) => {
    history.push("/admin/recycables/show/" + id);
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Client Recycables</h4>
        </CardHeader>
        <CardBody>
          {recycablesData && (
            <ClientRecycablesTable
              rows={recycablesData.data}
              totalRows={recycablesData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              showRecycable={showRecycableHandler}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ClientRecycables;
